import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import MasterIndustryAddForm from "./MasterIndustryAddForm";

const MasterIndustryAdd = ({ buttonConfig, isButtonClicked }) => {
  const schema = z.object({
    industry: z.string().nonempty(),
    industry_code: z.string().nonempty(),
    basic_industry: z.string().nonempty(),
    sector: z.string().nonempty(),

    sector_code: z.string().nonempty(),
    mes_code: z.string().nonempty(),
    macro_economic_sector: z.string().nonempty(),
    bi_code: z.string().nonempty(),

    vidal_code: z.string().nonempty(),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const form = useForm({
    defaultValues: {
      status: "true",
      eff_end_date: null,
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterIndustryAddForm
      form={form}
      segmentName={buttonConfig.name}
      addHandler={buttonConfig.addHandler}
      closeHandler={buttonConfig.closeAddModal}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterIndustryAdd;
